module.exports = __webpack_public_path__ + "img/TeamComic_004.2f1de6ba.png";